"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LanguageProvider = exports.LanguageContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _contexts = require("../sfra-api/contexts");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const LanguageContext = exports.LanguageContext = /*#__PURE__*/_react.default.createContext({});
const LanguageProvider = ({
  locale,
  children
}) => {
  const SFRAClient = (0, _contexts.useCommerceSFRAAPI)();
  locale = locale.replace(/-/g, '_');
  const [i18n, setI18n] = (0, _react.useState)({
    locale: locale,
    currentCountry: {
      country: '',
      lang: '',
      config: {}
    },
    countries: [],
    error: null
  });
  (0, _react.useEffect)(() => {
    // @ts-ignore
    SFRAClient.Site.getLocales().then(({
      countries
    }) => {
      var _selectedLang$name;
      const selectedCountry = countries === null || countries === void 0 ? void 0 : countries.find(country => country.locales.find(lang => lang.locale === locale));
      const selectedLang = (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.locales.find(lang => lang.locale === locale)) || {};
      setI18n({
        locale: locale,
        countries,
        currentCountry: {
          country: (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.countryName) || '',
          lang: (selectedLang === null || selectedLang === void 0 ? void 0 : (_selectedLang$name = selectedLang.name) === null || _selectedLang$name === void 0 ? void 0 : _selectedLang$name.split(' ')[0]) || '',
          config: (selectedCountry === null || selectedCountry === void 0 ? void 0 : selectedCountry.config) || {}
        }
      });
    }).catch(err => {
      setI18n(err);
    });
  }, [locale]);
  return /*#__PURE__*/_react.default.createElement(LanguageContext.Provider, {
    value: i18n
  }, children);
};
exports.LanguageProvider = LanguageProvider;